import { useLocation } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function StatsPage() {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const stockUrl = searchParams.get('url');
    const [stats, setStats] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
      console.log("StatsPage mounted");
      return () => console.log("StatsPage unmounted");
    }, []);

    useEffect(() => {
        let isMounted = true;  // Cleanup flag
        console.log("Fetching stats for URL:", stockUrl);
        const fetchStats = async () => {
            try {
                const response = await fetch(`/stocktracker/api/stock-stats?url=${encodeURIComponent(stockUrl)}`);
                const data = await response.json();
                if (!isMounted) return;  // Skip if unmounted
                if (data.error) throw new Error(data.error);
                setStats(data);
            } catch (err) {
                if (isMounted) setError(err.message);
            } finally {
                if (isMounted) setLoading(false);
            }
        };
        fetchStats();
        console.log("Fetched stats for URL:", stockUrl);
        return () => { isMounted = false; };  // Cleanup on unmount
    }, [stockUrl]);

    if (loading) return <div className="loading">Loading statistics...</div>;
    if (error) return <div className="error">Error: {error}</div>;

    return (
        <div className="stats-container">
            <h2>Advanced Statistics</h2>
            <div className="stats-grid">
                <StatCard title="Daily_Change_Value" value={stats['Daily_Change_Value']} />
                <StatCard title="5_Days_Change_Value" value={stats['5_Days_Change_Value']} />
                <StatCard title="10_Days_Change_Value" value={stats['10_Days_Change_Value']} />
                <StatCard title="1_Month_Change_Value" value={stats['1_Month_Change_Value']} />
                <StatCard title="3_Months_Change_Value" value={stats['3_Months_Change_Value']} />
                <StatCard title="Daily_Change_Pct" value={stats['Daily_Change_Pct']} />
                <StatCard title="5_Days_Change_Pct" value={stats['5_Days_Change_Pct']} />
                <StatCard title="10_Days_Change_Pct" value={stats['10_Days_Change_Pct']} />
                <StatCard title="1_Month_Change_Pct" value={stats['1_Month_Change_Pct']} />
                <StatCard title="3_Months_Change_Pct" value={stats['3_Months_Change_Pct']} />
                <StatCard title="Max_1_Year" value={stats['Max_1_Year']} />
                <StatCard title="Min_1_Year" value={stats['Min_1_Year']} />
                <StatCard title="nb_days_>_5%_in_last_3_months" value={stats['nb_days_>_5%_in_last_3_months']} />
                <StatCard title="nb_days_<_-5%_in_last_3_months" value={stats['nb_days_<_-5%_in_last_3_months']} />
                <StatCard title="nb_days_>_10%_in_last_6_months" value={stats['nb_days_>_10%_in_last_6_months']} />
                <StatCard title="nb_days_<_-10%_in_last_6_months" value={stats['nb_days_<_-10%_in_last_6_months']} />
                <StatCard title="Nb Pics a 15% (31 jours)" value={stats['Local_Max_Count_2Y']} />
                <StatCard title="Nb Trous a 15% (31 jours)" value={stats['Local_Min_Count_2Y']} />
                <StatCard title="Nb Pics a 15% (31 jours)_opt" value={stats['Local_Max_Count_2Y_opt']} />
                <StatCard title="Nb Trous a 15% (31 jours)_opt" value={stats['Local_Min_Count_2Y_opt']} />
                <StatCard title="Pct_Change_520d" value={stats['Pct_Change_520d']} />
            </div>
        </div>
    );
}

const StatCard = ({ title, value }) => (
    <div className="stat-card">
        <h3>{title}</h3>
        <p>{value}</p>
    </div>
);